import "./code.8918539b.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireee1d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireee1d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fmzeE", function(module, exports) {

$parcel$export(module.exports, "showSuccess", function () { return $b2f43e0fbbd5a32c$export$d841eba85c078f0b; });
$parcel$export(module.exports, "showError", function () { return $b2f43e0fbbd5a32c$export$3879b24e8245693d; });
// ============================================
// Toast Notifications Module
// ============================================
/**
 * Shows a toast notification.
 * @param {string} message  - Message to display
 * @param {'success'|'error'|'info'|'warning'} type - Toast type
 * @param {number} duration - Duration in milliseconds (default: 3000)
 */ function $b2f43e0fbbd5a32c$export$f6cef6fcf9ca4e17(message, type = 'info', duration = 3000) {
    let container = document.getElementById('toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'toast-container';
        container.className = 'fb-toast-container';
        container.setAttribute('aria-atomic', 'true');
        document.body.appendChild(container);
    }
    // Update aria-live on every toast so errors always get 'assertive'
    container.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');
    const toast = document.createElement('div');
    toast.className = `fb-toast fb-toast-${type}`;
    toast.setAttribute('role', type === 'error' ? 'alert' : 'status');
    const icons = {
        success: 'fa-circle-check',
        error: 'fa-circle-exclamation',
        info: 'fa-circle-info',
        warning: 'fa-triangle-exclamation'
    };
    const icon = icons[type] || icons.info;
    const iconEl = document.createElement('i');
    iconEl.className = `fa-solid ${icon}`;
    iconEl.setAttribute('aria-hidden', 'true');
    const textEl = document.createElement('span');
    textEl.textContent = message;
    toast.appendChild(iconEl);
    toast.appendChild(textEl);
    container.appendChild(toast);
    setTimeout(()=>toast.classList.add('show'), 10);
    setTimeout(()=>{
        toast.classList.remove('show');
        setTimeout(()=>{
            if (container.contains(toast)) container.removeChild(toast);
            if (container.children.length === 0 && document.body.contains(container)) document.body.removeChild(container);
        }, 300);
    }, duration);
}
function $b2f43e0fbbd5a32c$export$d841eba85c078f0b(message) {
    $b2f43e0fbbd5a32c$export$f6cef6fcf9ca4e17(message, 'success');
}
function $b2f43e0fbbd5a32c$export$3879b24e8245693d(message) {
    $b2f43e0fbbd5a32c$export$f6cef6fcf9ca4e17(message, 'error');
}
function $b2f43e0fbbd5a32c$export$3ddc711ac21275cd(message) {
    $b2f43e0fbbd5a32c$export$f6cef6fcf9ca4e17(message, 'info');
}
function $b2f43e0fbbd5a32c$export$da2f4e8190fdb5e1(message) {
    $b2f43e0fbbd5a32c$export$f6cef6fcf9ca4e17(message, 'warning');
}

});

// ============================================
// Solve Page Entry Point (solve.html)
// ============================================

parcelRequire("5Qu0e");



var $16TLO = parcelRequire("16TLO");

var $fmzeE = parcelRequire("fmzeE");
// ============================================
// FizzBuzz Core Algorithm
// ============================================
/**
 * A single FizzBuzz result item.
 * @typedef {{ value: number, label: string }} FizzBuzzItem
 */ /**
 * Validates FizzBuzz inputs.
 *
 * @param {number} fizz  - Fizz divisor
 * @param {number} buzz  - Buzz divisor
 * @param {number} limit - Upper bound (inclusive)
 * @returns {{ valid: boolean, error: string|null }}
 */ function $7b38401064ace4c0$export$b8d6bda6b8a0445d(fizz, buzz, limit) {
    if (!Number.isInteger(fizz) || fizz < 2 || fizz > 100) return {
        valid: false,
        error: 'Fizz divisor must be an integer between 2 and 100.'
    };
    if (!Number.isInteger(buzz) || buzz < 2 || buzz > 100) return {
        valid: false,
        error: 'Buzz divisor must be an integer between 2 and 100.'
    };
    if (!Number.isInteger(limit) || limit < 1 || limit > 1000) return {
        valid: false,
        error: 'Count To must be an integer between 1 and 1000.'
    };
    return {
        valid: true,
        error: null
    };
}
function $7b38401064ace4c0$export$ee099e9526bafddb(fizz, buzz, limit) {
    const results = [];
    for(let i = 1; i <= limit; i++){
        const isFizz = i % fizz === 0;
        const isBuzz = i % buzz === 0;
        let label;
        if (isFizz && isBuzz) label = 'FizzBuzz';
        else if (isFizz) label = 'Fizz';
        else if (isBuzz) label = 'Buzz';
        else label = String(i);
        results.push({
            value: i,
            label: label
        });
    }
    return results;
}
function $7b38401064ace4c0$export$2cf3d65bc6f74f7d(label) {
    if (label === 'FizzBuzz') return 'fizzbuzz';
    if (label === 'Fizz') return 'fizz';
    if (label === 'Buzz') return 'buzz';
    return 'number';
}
function $7b38401064ace4c0$export$3512942180f1c205(results) {
    let fizz = 0;
    let buzz = 0;
    let fizzbuzz = 0;
    let numbers = 0;
    for (const item of results){
        const type = $7b38401064ace4c0$export$2cf3d65bc6f74f7d(item.label);
        if (type === 'fizzbuzz') fizzbuzz++;
        else if (type === 'fizz') fizz++;
        else if (type === 'buzz') buzz++;
        else numbers++;
    }
    return {
        fizz: fizz,
        buzz: buzz,
        fizzbuzz: fizzbuzz,
        numbers: numbers
    };
}


// ============================================
// Results Display Module
// ============================================

function $d6b57e3774a7cadd$export$9aa35f3185551f42(results) {
    $d6b57e3774a7cadd$var$renderSequence(results);
    $d6b57e3774a7cadd$var$renderStats(results);
}
/**
 * Renders the color-coded badge grid.
 * @param {import('./fizzBuzz.js').FizzBuzzItem[]} results
 */ function $d6b57e3774a7cadd$var$renderSequence(results) {
    const output = document.getElementById('resultsOutput');
    if (!output) {
        console.error('resultsOutput element not found');
        return;
    }
    if (results.length === 0) {
        output.innerHTML = '<p class="text-muted">No results to display.</p>';
        return;
    }
    const fragment = document.createDocumentFragment();
    for (const item of results){
        const type = (0, $7b38401064ace4c0$export$2cf3d65bc6f74f7d)(item.label);
        const span = document.createElement('span');
        span.className = `badge result-badge ${type}-badge`;
        span.setAttribute('title', `${item.value}: ${item.label}`);
        span.textContent = item.label;
        fragment.appendChild(span);
    }
    output.textContent = '';
    output.appendChild(fragment);
}
/**
 * Renders the statistics bar.
 * @param {import('./fizzBuzz.js').FizzBuzzItem[]} results
 */ function $d6b57e3774a7cadd$var$renderStats(results) {
    const stats = document.getElementById('statsDisplay');
    if (!stats) return;
    if (results.length === 0) {
        stats.textContent = '';
        return;
    }
    const counts = (0, $7b38401064ace4c0$export$3512942180f1c205)(results);
    const total = results.length;
    stats.textContent = '';
    const items = [
        {
            label: 'Total',
            value: total,
            cls: 'text-secondary'
        },
        {
            label: 'Fizz',
            value: counts.fizz,
            cls: 'text-primary'
        },
        {
            label: 'Buzz',
            value: counts.buzz,
            cls: 'text-success'
        },
        {
            label: 'FizzBuzz',
            value: counts.fizzbuzz,
            cls: 'text-warning'
        },
        {
            label: 'Numbers',
            value: counts.numbers,
            cls: 'text-muted'
        }
    ];
    for (const item of items){
        const span = document.createElement('span');
        span.className = `stats-item me-3 small ${item.cls}`;
        span.innerHTML = `<strong>${item.label}:</strong> ${item.value}`;
        stats.appendChild(span);
    }
}


// ── DOM references ──────────────────────────────────────────────────────────
const $5d7bff4e2c8e0713$var$fizzInput = document.getElementById('fizzInput');
const $5d7bff4e2c8e0713$var$buzzInput = document.getElementById('buzzInput');
const $5d7bff4e2c8e0713$var$limitInput = document.getElementById('limitInput');
const $5d7bff4e2c8e0713$var$generateBtn = document.getElementById('generateBtn');
const $5d7bff4e2c8e0713$var$resetBtn = document.getElementById('resetBtn');
const $5d7bff4e2c8e0713$var$DEFAULTS = {
    fizz: 3,
    buzz: 5,
    limit: 100
};
// ── Init ─────────────────────────────────────────────────────────────────────
(0, $16TLO.initThemeToggle)();
// ── Actions ───────────────────────────────────────────────────────────────────
function $5d7bff4e2c8e0713$var$generate() {
    const fizz = parseInt($5d7bff4e2c8e0713$var$fizzInput.value, 10);
    const buzz = parseInt($5d7bff4e2c8e0713$var$buzzInput.value, 10);
    const limit = parseInt($5d7bff4e2c8e0713$var$limitInput.value, 10);
    const validation = (0, $7b38401064ace4c0$export$b8d6bda6b8a0445d)(fizz, buzz, limit);
    if (!validation.valid) {
        (0, $fmzeE.showError)(validation.error);
        return;
    }
    const results = (0, $7b38401064ace4c0$export$ee099e9526bafddb)(fizz, buzz, limit);
    (0, $d6b57e3774a7cadd$export$9aa35f3185551f42)(results);
    (0, $fmzeE.showSuccess)(`Generated FizzBuzz from 1 to ${limit} (Fizz=${fizz}, Buzz=${buzz}).`);
}
function $5d7bff4e2c8e0713$var$resetDefaults() {
    $5d7bff4e2c8e0713$var$fizzInput.value = $5d7bff4e2c8e0713$var$DEFAULTS.fizz;
    $5d7bff4e2c8e0713$var$buzzInput.value = $5d7bff4e2c8e0713$var$DEFAULTS.buzz;
    $5d7bff4e2c8e0713$var$limitInput.value = $5d7bff4e2c8e0713$var$DEFAULTS.limit;
    $5d7bff4e2c8e0713$var$generate();
}
// ── Event listeners ───────────────────────────────────────────────────────────
$5d7bff4e2c8e0713$var$generateBtn.addEventListener('click', $5d7bff4e2c8e0713$var$generate);
$5d7bff4e2c8e0713$var$resetBtn.addEventListener('click', $5d7bff4e2c8e0713$var$resetDefaults);
[
    $5d7bff4e2c8e0713$var$fizzInput,
    $5d7bff4e2c8e0713$var$buzzInput,
    $5d7bff4e2c8e0713$var$limitInput
].forEach((input)=>{
    input.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') $5d7bff4e2c8e0713$var$generate();
    });
});
// ── Auto-generate on load ─────────────────────────────────────────────────────
$5d7bff4e2c8e0713$var$generate();
console.log('FizzBuzz solve page initialized');


//# sourceMappingURL=solve.5d9dc799.js.map
